
$(document).ready(function() {
  $('.brand-card').on('click', function(e) {
    e.preventDefault();
    let selectorId = $(this).attr('href');
    
      $('html, body').animate({
        scrollTop: $(selectorId).offset().top,
      });
  });
  $('.back-to-top').on('click', function(e) {
    e.preventDefault();
    let selectorId = $(this).attr('href');
    
      $('html, body').animate({
        scrollTop: $(selectorId).offset().top,
      });
  });
});
// Collapse the product spec tables (e.g. rotor specs) by default on load.
// These tables use the class ".hiddentable" and are toggled by the
// ".show-hidden-table" trigger below.
$(function () {
  $('.hiddentable').addClass('is-collapsed');
});

// Swap the word EXPAND <-> COLLAPSE in a trigger's label while preserving the
// original casing (ALL CAPS, Capitalized, or lowercase). Walks text nodes so
// nested markup (spans, <strong>, etc.) inside the button is left intact.
function umMatchCase(src, word) {
  if (src === src.toUpperCase()) return word.toUpperCase();
  if (src.charAt(0) === src.charAt(0).toUpperCase()) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }
  return word;
}
function umSwapLabel($el, opening) {
  $el.contents().each(function () {
    if (this.nodeType === 3) {
      if (opening) {
        this.nodeValue = this.nodeValue.replace(/expand/gi, function (m) {
          return umMatchCase(m, 'collapse');
        });
      } else {
        this.nodeValue = this.nodeValue.replace(/collapse/gi, function (m) {
          return umMatchCase(m, 'expand');
        });
      }
    } else if (this.nodeType === 1) {
      umSwapLabel($(this), opening);
    }
  });
}

$(document).on('click', '.show-hidden-table', function (e) {
  e.preventDefault();
  var $btn = $(this);

  // Find collapsible spec tables associated with THIS trigger.
  // Product pages place ".hiddentable" tables after / near the button.
  var $tables = $btn.nextAll('.hiddentable');
  if (!$tables.length) $tables = $btn.parent().find('.hiddentable');
  if (!$tables.length) $tables = $btn.closest('div').find('.hiddentable');

  if ($tables.length) {
    // Collapsible product spec tables: toggle open/closed, keep the trigger
    // visible so it can collapse again.
    var opening = $tables.first().hasClass('is-collapsed');
    $tables.toggleClass('is-collapsed', !opening);
    $btn.toggleClass('is-expanded', opening);
    umSwapLabel($btn, opening);
    return;
  }

  // Legacy one-way reveal (video / finance / sell pages) uses ".hidden-table".
  $('.hidden-table').css({
    opacity: '100%',
    height: 'auto',
    overflow: 'auto',
  });
  $('.show-hidden-table').hide();
});